'use client'

import { useEffect, useState } from 'react'

/**
 * Phone-width breakpoint for the mobile app shell (below Tailwind's `md`).
 * Tablets and small desktops (>= 768px) keep the regular sidebar layout.
 */
const MOBILE_QUERY = '(max-width: 767px)'

/**
 * True when the viewport is phone-sized.
 *
 * Returns false until mounted so SSR and the hydration render agree on the
 * desktop layout; the mobile shell settles on the first client frame (same
 * pattern as useViewportWidth / DesktopRecommendedBanner).
 */
export default function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY)
    const update = () => setIsMobile(mql.matches)
    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [])

  return isMobile
}
